import { css } from "@emotion/react";

export const e_menu_items = css({
    padding: 0,
    listStyle : 'none',
    height: '100%',
    overflow: 'auto'
    
})